import { useCallback } from 'react';
import { NavigateOptions, To, useNavigate } from 'react-router';

import { unawaited } from './promise';

export function useUnawaitedNavigate() {
  const navigate = useNavigate();
  return useCallback(
    (to: To, options?: NavigateOptions) => unawaited(navigate(to, options)),
    [navigate],
  );
}
